import { Box, Checkbox, FormControlLabel } from "@mui/material"
import type { ChangeEvent, FC } from "react"

import { PAY_FILE_TYPE_TO_LABEL } from "../../constants"

import { PayFileType } from "@/graphql/codegen/graphql"

const PAY_FILE_TYPE_LIST = Object.values(PayFileType)

interface PayFileTypeFilterProps {
  type: PayFileType | undefined
  onChange: (type: PayFileType | undefined) => void
}

export const PayFileTypeFilter: FC<PayFileTypeFilterProps> = ({ type, onChange }) => {
  const handleTypeToggle = (payFileType: PayFileType) => (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked ? payFileType : undefined)
  }

  return (
    <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
      {PAY_FILE_TYPE_LIST.map((payFileType) => (
        <FormControlLabel
          key={payFileType}
          control={
            <Checkbox
              checked={type === payFileType}
              onChange={handleTypeToggle(payFileType)}
              data-testid={`pay-file.filter-drawer.type-checkbox-${payFileType}`}
            />
          }
          label={PAY_FILE_TYPE_TO_LABEL[payFileType]}
          className='w-full text-ellipsis'
        />
      ))}
    </Box>
  )
}
